var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 -0.00012207H38.25C42.075 -0.00012207 45 2.92488 45 6.74988V47.2499C45 51.0749 42.075 53.9999 38.25 53.9999H15.75C11.925 53.9999 9 51.0749 9 47.2499V6.74988C9 2.92488 11.925 -0.00012207 15.75 -0.00012207Z",
    fill: "#00BEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.50037H20.25L22.5 6.75037H31.5L33.75 4.50037H38.25C39.6 4.50037 40.5 5.40037 40.5 6.75037V47.2504C40.5 48.6004 39.6 49.5004 38.25 49.5004H15.75C14.4 49.5004 13.5 48.6004 13.5 47.2504V6.75037C13.5 5.40037 14.4 4.50037 15.75 4.50037Z",
    fill: "#93E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 4.50037V27.0004L36 24.7504H54V4.50037H31.5Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.875 19.7998L42.75 20.2498L41.625 19.7998C38.25 18.6748 36 15.7498 36 12.1498C36 10.3498 37.35 8.99976 39.15 8.99976C40.725 8.99976 41.175 9.67476 42.75 11.2498C44.1 9.89976 44.775 8.99976 46.35 8.99976C51.3 8.99976 50.175 17.7748 43.875 19.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.7504V38.2504H18L22.5 40.5004V24.7504H0Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 29.2498H9V33.7498H4.5V29.2498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 29.2498H18V33.7498H13.5V29.2498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.0e42c9935c8924e01fd55d418a62d2e3.svg";
export { ForwardRef as ReactComponent };